export function formatDollars(n: number, decimalDigits: number = 2): string {
  const numberFormatOptions = {
    minimumFractionDigits: decimalDigits,
    maximumFractionDigits: decimalDigits,
  };

  if (n < 0) {
    return `-$${(-1 * n).toLocaleString(undefined, numberFormatOptions)}`;
  }

  return `$${n.toLocaleString(undefined, numberFormatOptions)}`;
}

export function formatDollarsFromCents(
  n: number,
  decimalDigits: number = 2
): string {
  return formatDollars(n / 100, decimalDigits);
}
